import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';

import { WorkloadConfigChangedEventDetails } from '@cast/types';

export const countConfigActions = (
  event: WorkloadConfigChangedEventDetails
): number => {
  if (!event) {
    return 0;
  }
  const predicates: Array<(e: WorkloadConfigChangedEventDetails) => boolean> = [
    (e): boolean =>
      !isEqual(
        e.previous.workloadConfig.vpaConfig.containerConstraints,
        e.current.workloadConfig.vpaConfig.containerConstraints
      ),
    (e): boolean =>
      e.previous.scalingPolicyConfig.id !== e.current.scalingPolicyConfig.id,
    (e): boolean =>
      e.previous.workloadConfig.hpaConfig.managementOption !==
      e.current.workloadConfig.hpaConfig.managementOption,
    (e): boolean => {
      const comparedProperties = ['minReplicas', 'maxReplicas'];
      return !isEqual(
        pick(e.previous.workloadConfig.hpaConfig, comparedProperties),
        pick(e.current.workloadConfig.hpaConfig, comparedProperties)
      );
    },
    (e): boolean =>
      e.previous.workloadConfig.vpaConfig.managementOption !==
      e.current.workloadConfig.vpaConfig.managementOption,
  ];

  return predicates.reduce((acc, predicate) => {
    if (predicate(event)) {
      return acc + 1;
    }
    return acc;
  }, 0);
};
